import React from 'react';
import { Typography } from '@routific/hive/v5';
import { DeliveryMethod } from '../../../../store/mst/models';
import { LandlinePhoneNumberWarning } from './LandlinePhoneNumberWarning';
import { isLandline } from '../../../../helpers/forms/phoneUtils';

interface Props {
  phone: string;
  deliveryMethod?: DeliveryMethod;
}

const PhoneNumberRow: React.FC<Props> = ({ phone, deliveryMethod }) => (
  <>
    <Typography variant="body" data-testid="order-details-content-phone-number">
      {phone}
    </Typography>
    {deliveryMethod === DeliveryMethod.SMS && isLandline(phone) && <LandlinePhoneNumberWarning/>}
  </>
);

export default PhoneNumberRow;
